'use client';

import { Skeleton } from '@mui/material';
import { AboutSection } from './styles';

export const BrokerHeroSkeleton = () => {
  return (
    <AboutSection>
      <Skeleton variant="text" width={120} height={28} animation="wave" style={{ marginBottom: 12 }} />
      <Skeleton variant="text" width="100%" height={16} animation="wave" />
      <Skeleton variant="text" width="95%" height={16} animation="wave" />
      <Skeleton variant="text" width="88%" height={16} animation="wave" />
      <Skeleton variant="text" width="70%" height={16} animation="wave" />
    </AboutSection>
  );
};
